import { render } from "./FeedBackIzvestajSamoprocena.vue?vue&type=template&id=3e20feac&scoped=true&lang=html"
import script from "./FeedBackIzvestajSamoprocena.vue?vue&type=script&lang=js"
export * from "./FeedBackIzvestajSamoprocena.vue?vue&type=script&lang=js"

import "./FeedBackIzvestajSamoprocena.vue?vue&type=style&index=0&id=3e20feac&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-3e20feac"

export default script